import { map } from 'lodash'
import React from 'react'

import { NeighborhoodType } from '../../types'

type Props = {
  selectedNeighborhood: NeighborhoodType
  neighborhoods: NeighborhoodType[]
  onChange: (neighborhood: NeighborhoodType) => void
}

const NeighborhoodTabs: React.FC<Props> = ({ selectedNeighborhood, neighborhoods, onChange }) => {
  return (
    <div className="tabs">
      {map(neighborhoods, (neighborhood: NeighborhoodType, index: number) => (
        <div
          key={index}
          className={`tabs__element ${
            selectedNeighborhood.name.toLowerCase() === neighborhood.name.toLowerCase() ? 'tabs__element--selected' : ''
          }`}
          onClick={() => onChange(neighborhood)}
        >
          {neighborhood.name}
        </div>
      ))}
    </div>
  )
}

export default NeighborhoodTabs
